<template>
  <Card>
    <template slot="header">Invoices</template>
    <v-progress-linear
      v-if="loading"
      :indeterminate="true"
    />
    <v-data-table
      :headers="headers"
      :items="invoices"
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.stamp }}</td>
        <td>{{ props.item.invoiceID }}</td>
        <td>${{ props.item.paid }}</td>
        <td class="text-xs-right">
          <IconButton
            :to="'/print/invoice/' + props.item.invoiceID"
            tooltip="View"
            color="indigo"
            icon="fa-eye"
          />
        </td>
      </template>
    </v-data-table>
  </Card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      loading: true,
      headers: [
        {
          text: 'Time Stamp',
          align: 'left',
          sortable: true,
          value: 'accountEntryID'
        },
        {
          text: 'InvoiceID',
          align: 'left',
          sortable: true,
          value: 'paid'
        },
        {
          text: 'Payment Total',
          align: 'left',
          sortable: true,
          value: 'paid'
        },
        {
          text: 'View',
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      invoices: 'invoices/invoices'
    })
  },
  mounted () {
    this.getInvoices().then(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions({
      getInvoices: 'invoices/getInvoices'
    })
  }
}
</script>
